import { render, staticRenderFns } from "./add-minichallenge.vue?vue&type=template&id=3c388b58&scoped=true&"
import script from "./add-minichallenge.vue?vue&type=script&lang=js&"
export * from "./add-minichallenge.vue?vue&type=script&lang=js&"
import style0 from "./add-minichallenge.vue?vue&type=style&index=0&lang=css&"
import style1 from "./add-minichallenge.vue?vue&type=style&index=1&id=3c388b58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c388b58",
  null
  
)

export default component.exports